import { InvoiceHistoryToolPanel } from "../InvoiceHistoryToolPanel";
import { Button, DataSource, HorizontalSpacer, Layout, SearchPanel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutInvoiceHistoryList extends Layout {
    buttonAddBalanceDue: Button;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    horizontalspacer4: HorizontalSpacer;
    layoutInvoiceHistoryToolPanel: InvoiceHistoryToolPanel;
    searchpanelInvoices: SearchPanel;
    sourceEdiBillingList: DataSource;
    switchBatchRange: Switch;
    switchErrors: Switch;
    switchIsIntercompany: Switch;
    switchRebilled: Switch;
    switchSplitBill: Switch;
    tableInvoices: Table;
    textboxBatchHistoryCreateDate: Textbox;
    textboxBatchHistoryID: Textbox;
    textboxBeginningBatch: Textbox;
    textboxBillType: Textbox;
    textboxCreateDate: Textbox;
    textboxCustomerId: Textbox;
    textboxDirection: Textbox;
    textboxEndingBatch: Textbox;
    textboxErrorDescription: Textbox;
    textboxErrorType: Textbox;
    textboxInvoiceNoString: Textbox;
    textboxOrderId: Textbox;
    textboxPartnerId: Textbox;
    textboxReadyToSend: Textbox;
    textboxReferenceNumbers: Textbox;
    textboxTransactionSequence: Textbox;
    textboxUpdatedOn: Textbox;
}
